import { ErrorData } from 'ok-angular-shared/components';

export const appErrorCodes: ErrorData[] = [];
